import { render } from "./CommonShowMore.vue?vue&type=template&id=225a2174"
import script from "./CommonShowMore.vue?vue&type=script&lang=js"
export * from "./CommonShowMore.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/7d7b898a4c764117/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__